import {
	Box,
	Link,
	Button,
	HStack,
	Stack,
	Image,
	Spacer,
	Text,
	VStack,
	useColorMode,
	useDisclosure
} from '@chakra-ui/react'
import { Modal, ModalOverlay, ModalContent } from '@chakra-ui/react'
import React from 'react'
import { FiEye } from 'react-icons/fi'
import { motion } from 'framer-motion'
import { FiCalendar } from 'react-icons/fi'
import { getTokens } from '../../config/colorTokens'

const MotionBox = motion(Box)

const Publication = (props) => {
	const { colorMode } = useColorMode()
	const { isOpen, onOpen, onClose } = useDisclosure()
	const t = getTokens(colorMode)
	const size = props.description === 'ICACCS-2023 · IEEE' ? 'md' : '3xl'

	return (
		<>
			<Modal
				motionPreset="slideInBottom"
				isOpen={isOpen}
				onClose={onClose}
				size={{ base: 'xs', md: 'xl', lg: size }}
				isCentered>
				<ModalOverlay backdropFilter="blur(3px)" />
				<ModalContent>
					<Image borderRadius="8px" src={props.certificate} />
				</ModalContent>
			</Modal>
			<MotionBox
				variants={props.variants}
				whileHover={{
					scale: 1.02,
					transition: { type: 'spring', stiffness: 300, damping: 20 }
				}}>
				<Stack
					direction={{ base: 'column', md: 'row' }}
					border="1px"
					borderRadius="10px"
					borderColor={t.borderCard}
					backdropFilter={'blur(5px)'}
					width="100%"
					p={4}>
					<HStack>
						<VStack alignItems="left" spacing={0} p={0}>
							<Link href={props.link} target="_blank" fontSize="md" fontWeight="bold">
								{props.title}
							</Link>
							<Text fontSize="sm" fontWeight="semibold">
								{props.description}
							</Text>
							<Text color={t.textMuted} fontSize="sm" display="flex" alignItems="center">
								<FiCalendar />
								&nbsp;{props.date}
							</Text>
						</VStack>
					</HStack>
					<Spacer />
					<Image
						display={{ base: 'none', md: 'block' }}
						onClick={onOpen}
						style={{ height: '70px', width: '100px' }}
						borderRadius="5px"
						_hover={{
							cursor: 'pointer'
						}}
						src={props.certificate}
					/>
					<Box display={{ base: 'block', md: 'none' }}>
						<Button
							border="1px"
							borderRadius="10px"
							borderColor={t.borderCard}
							as={Link}
							href={props.website}
							p={0}
							w={{ base: 'full' }}
							target="_blank"
							bg="none"
							fontWeight="normal"
							leftIcon={<FiEye />}
							onClick={onOpen}
							_hover={{
								textDecoration: 'none',
								bg: t.hoverBg
							}}>
							View Certificate
						</Button>
					</Box>
				</Stack>
			</MotionBox>
		</>
	)
}

export default Publication
